import * as t from "io-ts";

export const LocationMetaActivityStateCodec = t.keyof({
  ON_SITE: null,
  IN_TRANSIT: null,
  STOPPED: null,
  OFFLINE: null,
  UNKNOWN: null,
});
export type LocationMetaActivityState = t.TypeOf<typeof LocationMetaActivityStateCodec>;

export const LocationMetaActivityCodec = t.intersection([
  t.type({inShift: t.boolean, onSite: t.boolean, status: t.string}),
  t.partial({state: LocationMetaActivityStateCodec, observedDttm: t.number, calculatedDttm: t.number}),
]);
export type LocationMetaActivity = t.TypeOf<typeof LocationMetaActivityCodec>;

/** Display summary only; independent shift/site facts remain available on activity. */
export function locationActivityState(status: string): LocationMetaActivityState {
  switch (status) {
    case "AT_SITE":
    case "ON_SITE":
      return "ON_SITE";
    case "MOVING":
      return "IN_TRANSIT";
    case "IDLE":
      return "STOPPED";
    case "OFFLINE":
      return "OFFLINE";
    default:
      return "UNKNOWN";
  }
}
